import { atom } from "recoil";

const tutorialState = atom<string | null>({
  key: "tutorialState",
  default: null,
});

export default tutorialState;
